export default `p.yz*=rotate2D(-.3);
    float ss=3., s=1.;
    for(int j=0; j++<7;){
      p=abs(p); p.y-=.5;
      s = 1./clamp(dot(p,p),.0,1.);
      p*=s; ss*=s;
      p-=vec2(1.0,.1).xxy;
      p.xyz=p.zxy;
    }
    return length(p.xy)/ss-.01;
  }`